<template>
  <div class="layout px-0">
    <v-btn icon class="mx-0" v-if="!isMain">
      <v-icon color="teal" @click="setData('save')">save</v-icon>
    </v-btn>
    <v-btn icon class="mx-0" v-if="isMain">
      <v-icon color="teal" @click="setData('edit')">edit</v-icon>
    </v-btn>
    <v-btn icon class="mx-0">
      <v-icon color="pink" @click="setData('delete')">delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    orderItem: null,
    isMain: false,
    main: 'mainAction',
  }),
  methods: {
    setData(type) {
      let data = this.params.data;
      data.type = type;
      this.params.clicked(data);
    },
  },
  mounted() {
    this.isMain =
      this.params.colDef.field.toLowerCase() === this.main.toLowerCase();
  },
});
</script>